import { useMemo } from 'react'
import { PlugToken } from '../interfaces/common'
import useConfig from './useConfig'

const useToken = ({
  id,
  address,
  chain,
}: {
  id?: string
  address?: string
  chain?: number | string
}) => {
  const { tokens } = useConfig()

  const token = useMemo(() => {
    const normalizedAddress = address?.toLowerCase()

    return tokens.find((token) => {
      if (id) {
        return token.id === id
      } else if (address) {
        const addressMatch = token.address?.toLowerCase() === normalizedAddress

        if (addressMatch && chain) {
          return token.chain === chain || token.evmChain?.chainId === Number(chain)
        } else {
          return addressMatch
        }
      }
    })
  }, [tokens, id, address, chain])

  return token || ({} as Partial<PlugToken>)
}

export default useToken
